import React from 'react';
import { ActionMeta, MultiValue, SingleValue } from 'react-select';
import ReactAsyncSelect from 'react-select/async';

import { IOption, TFetchOption } from '../Input/Input';
import { TMenuPosition } from '../Select/Select';

interface IProps {
  value: IOption | IOption[];
  placeholder?: string;
  multiple?: boolean;
  disabled?: boolean;
  onChange: (value: IOption | IOption[]) => void;
  fetchOptions: TFetchOption;
  options?: IOption[];
  menuPosition?: TMenuPosition;
}

const AsyncSelect: React.FC<IProps> = ({ value, onChange, placeholder, multiple, disabled, fetchOptions, options, menuPosition }) => {
  const changeHandler = (value: SingleValue<IOption> | MultiValue<IOption>, actionMeta: ActionMeta<IOption>) => {
    if (multiple) {
      onChange(value as IOption[])
    } else {
      onChange(value as IOption);
    }
  }

  const promiseOptions = (input: string) => {
    if(input.length < 3) {
      return Promise.resolve([]);
    }
    return fetchOptions(input);
  }

  return (
    <ReactAsyncSelect
      onChange={changeHandler}
      cacheOptions
      loadOptions={promiseOptions}
      placeholder={placeholder}
      isMulti={multiple}
      value={value}
      isDisabled={disabled}
      menuPosition={menuPosition}
      noOptionsMessage={(input) => {
        const length = input.inputValue.length;
        if (length === 0) {
          return "Kirjoita hakuehto"
        } else if(length >= 1 && length <= 2) {
          return "Kirjoita vähintään 3 merkkiä."
        }
        return "Ei hakutuloksia...";
      }}
      isClearable

    />
  );
};

export default AsyncSelect;
